module.exports = __webpack_public_path__ + "img/speak-no-evil-monkey.712711cc.png";